import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  const handleCadastro = () => {
    window.open("https://forms.gle/jiHcGPWw6gXNCiWM8", "_blank");
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
      style={{
        background: "linear-gradient(135deg, hsl(16 98% 50%), hsl(29 98% 55%))"
      }}
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Sua casa pode ficar mais bonita e segura com o programa{" "}
            <span className="text-[hsl(var(--golden))]">Minha Casa Mais Bonita!</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-white/95 leading-relaxed">
            Pequenas reformas, grandes transformações. Ajuda técnica especializada para quem vai usar o programa Reforma Casa Brasil da Caixa.
          </p>

          <Button 
            onClick={handleCadastro}
            size="lg"
            className="bg-white text-[hsl(var(--orange-strong))] hover:bg-white/90 transition-all rounded-full px-8 py-6 text-lg font-bold shadow-[var(--shadow-warm)] hover:scale-105 transform"
          >
            Cadastre-se para participar
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>

          <p className="mt-6 text-white/80 text-sm md:text-base">
            Com apoio da Taboca Arquitetura e Cidades
          </p>
        </div>
      </div>

      {/* Decorative wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="hsl(var(--background))"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
